type ILinkResponseEatHereResource = {
	name: string;
	id: string;
	/**
	 * Can also be known as a deliveryOptionId, the "root" referenced is of type DeliveryOption.
	 */
	resourceRootId: string;
};

type ILinkResponseApp = {
	name: string;
	alias: string;
	id: string;
};

type ILinkResponseMenu = {
	id: string;
	displayName: string;
};

type ILinkResponsePlace = {
	id: string;
	displayName: string;
};

export interface ILinkResponse {
	id: string;
	url: string;
	merchantId?: string;
	app: ILinkResponseApp;
	place: ILinkResponsePlace | null;
	menu: ILinkResponseMenu | null;
	eatHereResource: ILinkResponseEatHereResource | null;
}

export class Link {
	id: string;
	url: string;
	merchantId?: string;
	app: ILinkResponseApp;
	place: ILinkResponsePlace | null;
	menu: ILinkResponseMenu | null;
	eatHereResource: ILinkResponseEatHereResource | null;

	constructor(values: ILinkResponse) {
		this.id = values?.id;
		this.url = values?.url;
		this.merchantId = values?.merchantId ?? undefined;
		this.app = values?.app ?? { name: "", alias: "", id: "" };
		this.place = values?.place ?? null;
		this.menu = values?.menu ?? null;
		this.eatHereResource = values?.eatHereResource ?? null;
	}
}
